export default __webpack_public_path__ + "static/legit-33f67ad8ea4b9d77f6528433db4e7e93.png";